import { LucideIcon, Package, TrendingUp, Users, ShoppingCart, Award, Gamepad2, MessageSquare, Tickets } from 'lucide-react';

export type AdminTabId = 'leaderboards' | 'products' | 'users' | 'orders' | 'rewards' | 'games' | 'kickbot' | 'community-raffles';

export interface AdminTab {
    id: AdminTabId;
    label: string;
    icon: LucideIcon;
    roles: Array<'admin' | 'mod'>;
}

export const ADMIN_TABS: AdminTab[] = [
    { id: 'leaderboards', label: 'Leaderboards', icon: TrendingUp, roles: ['admin', 'mod'] },
    { id: 'products', label: 'Products', icon: Package, roles: ['admin'] },
    { id: 'users', label: 'Users', icon: Users, roles: ['admin'] },
    { id: 'orders', label: 'Orders', icon: ShoppingCart, roles: ['admin', 'mod'] },
    { id: 'rewards', label: 'Rewards', icon: Award, roles: ['admin', 'mod'] },
    { id: 'games', label: 'Games', icon: Gamepad2, roles: ['admin', 'mod'] },
    { id: 'kickbot', label: 'Kick Bot', icon: MessageSquare, roles: ['admin', 'mod'] },
    { id: 'community-raffles', label: 'Raffles', icon: Tickets, roles: ['admin', 'mod'] },
];

export const DEFAULT_ADMIN_TAB: AdminTabId = 'leaderboards';
